import { Button, Heading, Paragraph, Popup, TriangleExclamationIcon } from '@quickmd-llc/design-system'
import {
  PLEASE_ENABLE_MICROPHONE_AND_CAMERA_DESCRIPTION_TEXT,
  PLEASE_ENABLE_MICROPHONE_AND_CAMERA_TITLE_TEXT,
  PLEASE_ENABLE_MICROPHONE_DESCRIPTION_TEXT,
  PLEASE_ENABLE_MICROPHONE_TITLE_TEXT,
  PLEASE_INSTALL_MICROPHONE_AND_CAMERA_DESCRIPTION_TEXT,
  PLEASE_INSTALL_MICROPHONE_AND_CAMERA_TITLE_TEXT,
  PLEASE_INSTALL_MICROPHONE_DESCRIPTION_TEXT,
  PLEASE_INSTALL_MICROPHONE_TITLE_TEXT,
} from 'utils/constants'

type Props = {
  media: 'video' | 'call'
  type: 'hardware' | 'permissions'
  onClose?: () => void
}

export const HardwarePermissionsPopUp = ({ media, type, onClose }: Props) => {
  const title =
    type === 'hardware' ?
      media === 'call' ?
        PLEASE_INSTALL_MICROPHONE_TITLE_TEXT
      : PLEASE_INSTALL_MICROPHONE_AND_CAMERA_TITLE_TEXT
    : media === 'call' ? PLEASE_ENABLE_MICROPHONE_TITLE_TEXT
    : PLEASE_ENABLE_MICROPHONE_AND_CAMERA_TITLE_TEXT
  const description =
    type === 'hardware' ?
      media === 'call' ?
        PLEASE_INSTALL_MICROPHONE_DESCRIPTION_TEXT
      : PLEASE_INSTALL_MICROPHONE_AND_CAMERA_DESCRIPTION_TEXT
    : media === 'call' ? PLEASE_ENABLE_MICROPHONE_DESCRIPTION_TEXT
    : PLEASE_ENABLE_MICROPHONE_AND_CAMERA_DESCRIPTION_TEXT

  return (
    <Popup
      isOpen
      lockOpen
      // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
      onClose={onClose}
      header={{
        content: (
          <div className='flex items-center gap-sp-1'>
            <TriangleExclamationIcon iconSize='l' /> <Heading level='h3'>{title}</Heading>
          </div>
        ),
      }}
      body={<Paragraph className='text-text-medium'>{description}</Paragraph>}
      footer={
        <div className='flex justify-end'>
          <Button priority='primary' onClick={onClose}>
            Close
          </Button>
        </div>
      }
    />
  )
}
